<template>
  <div 
    v-if="show" 
    class="element-context-menu" 
    :style="{ top: position.y + 'px', left: position.x + 'px' }"
    @click.stop
  >
    <div class="context-menu-global-actions">
      <div class="context-menu-action-item" @click="emitCreateBlock">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
           <line x1="12" y1="5" x2="12" y2="19"></line>
           <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        <span class="action-item-text">Créer un flux</span>
      </div>
      <div class="context-menu-action-item" @click="emitCreateVariable">
         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
           <path d="M12 5v14M5 12h14"/>
         </svg>
         <span class="action-item-text">Créer une variable</span>
      </div>
    </div>
    
    <div class="context-menu-header">
      <div class="search-input">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input 
          type="text" 
          ref="contextMenuSearch"
          placeholder="Rechercher un élément..." 
          v-model="searchQuery"
          @keydown.esc="emitClose"
        />
      </div>
    </div>
    <div class="context-menu-body">
      <div 
        v-for="item in filteredElementTypes" 
        :key="item.type" 
        class="context-menu-item"
        @click="emitInsertElement(item.type)"
        :title="item.description"
      >
        <div class="menu-item-content">
          <span class="menu-item-title">{{ item.title }}</span>
          <span class="menu-item-icon" v-html="item.iconSVG"></span>
        </div>
      </div>
      <div v-if="filteredElementTypes.length === 0" class="context-menu-empty">
        Aucun élément trouvé
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaygroundContextMenu',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    availableElementTypes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      searchQuery: ''
    }
  },
  computed: {
    filteredElementTypes() {
      const query = this.searchQuery.toLowerCase().trim();
      if (!query) return this.availableElementTypes;
      
      return this.availableElementTypes.filter(item => 
        item.title.toLowerCase().includes(query) || 
        item.description.toLowerCase().includes(query) ||
        item.type.toLowerCase().includes(query)
      );
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.searchQuery = '';
        this.$nextTick(() => {
          if (this.$refs.contextMenuSearch) {
            this.$refs.contextMenuSearch.focus();
          }
        });
      }
    }
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    emitCreateBlock() {
      this.$emit('create-block');
      this.emitClose();
    },
    emitCreateVariable() {
      this.$emit('create-variable');
      this.emitClose();
    },
    emitInsertElement(type) {
      this.$emit('insert-element', type);
      this.emitClose();
    }
  }
}
</script>

<style scoped>
.element-context-menu {
  position: absolute;
  width: 350px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 480px;
  animation: contextMenuScaleIn 0.15s cubic-bezier(0.16, 1, 0.3, 1);
  transform-origin: top left;
}

html.dark .element-context-menu {
  background: var(--dark-bg, #143028);
  border: 1px solid var(--dark-border-light, rgba(255, 255, 255, 0.1));
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
}

@keyframes contextMenuScaleIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.context-menu-global-actions {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e2e8f0;
  padding: 6px;
  gap: 6px;
  background: #f8fafc;
}

html.dark .context-menu-global-actions {
  border-bottom-color: var(--dark-border-light, rgba(255, 255, 255, 0.08));
  background: rgba(0, 0, 0, 0.15);
}

.context-menu-action-item {
  flex: 1;
  padding: 10px 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
}

.context-menu-action-item svg {
  margin-right: 8px;
  color: #64748b;
  transition: transform 0.15s ease;
}

.action-item-text {
  font-weight: 500;
  color: #334155;
  font-size: 0.9rem;
}

.context-menu-action-item:hover {
  background-color: #DAFFD1;
  transform: translateY(-1px);
}

.context-menu-action-item:hover svg,
.context-menu-action-item:hover .action-item-text {
  transform: scale(1.05);
  color: #0d2a1f !important;
}

html.dark .context-menu-action-item .action-item-text {
  color: #e2e8f0;
}

html.dark .context-menu-action-item svg {
  color: #94a3b8;
}

html.dark .context-menu-action-item:hover {
  background-color: #DAFFD1 !important;
}

html.dark .context-menu-action-item:hover svg,
html.dark .context-menu-action-item:hover .action-item-text {
  color: #0d2a1f !important;
}

.context-menu-header {
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

html.dark .context-menu-header {
  border-bottom-color: var(--dark-border-light, rgba(255, 255, 255, 0.08));
}

.context-menu-header .search-input {
  display: flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 10px 14px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}

.context-menu-header .search-input:focus-within {
  border-color: #cbd5e1;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(226, 232, 240, 0.4);
}

html.dark .context-menu-header .search-input {
  background: rgba(0, 0, 0, 0.25);
  border-color: transparent;
}

html.dark .context-menu-header .search-input:focus-within {
  background: rgba(0, 0, 0, 0.4);
  border-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.05);
}

.context-menu-header .search-input svg {
  color: #6b7280;
  margin-right: 8px;
}

.context-menu-header .search-input input {
  border: none;
  background: transparent;
  width: 100%;
  font-size: 0.9rem;
  color: #1f2937;
  outline: none;
}

html.dark .context-menu-header .search-input input {
  color: white;
}

html.dark .context-menu-header .search-input input::placeholder {
  color: #9ca3af;
}

.context-menu-body {
  overflow-y: auto;
  padding: 8px;
}

.context-menu-item {
  padding: 10px 14px;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.context-menu-item:last-child {
  margin-bottom: 0;
}

.context-menu-item:hover {
  background-color: #DAFFD1;
  transform: translateX(4px);
}

html.dark .context-menu-item:hover {
  background-color: #DAFFD1 !important;
}

.menu-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.menu-item-title {
  font-size: 0.9rem;
  font-weight: 500;
  color: #334155;
  transition: color 0.2s ease;
}

html.dark .menu-item-title {
  color: #f8fafc;
}

.context-menu-item:hover .menu-item-title {
  color: #0d2a1f !important;
}

html.dark .context-menu-item:hover .menu-item-title {
  color: #0d2a1f !important;
}

.menu-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  opacity: 0.8;
  transition: all 0.2s ease;
}

html.dark .menu-item-icon {
  color: #64748b;
}

.context-menu-item:hover .menu-item-icon {
  color: #0d2a1f !important;
  opacity: 1;
  transform: scale(1.1);
}

.context-menu-empty {
  padding: 20px;
  text-align: center;
  font-size: 0.9rem;
  color: #6b7280;
}

html.dark .context-menu-empty {
  color: #9ca3af;
}
</style>
